import "./Input.scss";

function Input({ label, name, value, type, placeholder }) {
  return (
    <div className="field">
      <label htmlFor={name} className="field__label">
        {label}
      </label>
      <input
        type={type}
        id={name}
        name={name}
        value={value}
        placeholder={placeholder}
        className="field__input"
      />
    </div>
  );
}

export default Input;
